import React from 'react';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      className="flex items-center justify-between shrink-0 px-6"
      style={{
        height: 36,
        borderTop: '1px solid var(--hub-line-2)',
        background: 'var(--hub-bg)',
        color: 'var(--hub-ink-3)',
        fontSize: 12,
        fontWeight: 400,
      }}
    >
      <span>MCPHub &copy; {year}</span>
      <span className="hub-mono" style={{ fontSize: 11 }}>
        v{import.meta.env.PACKAGE_VERSION || 'dev'}
      </span>
    </footer>
  );
};

export default Footer;